export default ".././fonts/empty.svg";